import styled from 'styled-components';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { useCallback, useContext, useEffect, useState } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import MultiSelectFilterCard from './SelectionFilterCard';
import { useSelector } from 'react-redux';
import { QuickFilter } from '../../types';

interface SelectionFilterProps {
  filterType:
    | SearchFiltersTypes.PROPERTY_TYPES
}

const SelectionFilter = ({ filterType }: SelectionFilterProps) => {
  const { filterOptions } = useContext(SearchContext) as SearchContextInterface;
  const quickFilter = useSelector((state: any) => state.map.quickFilter);
  const compounds = useSelector((state: any) => state.map.compounds);

  const [options, setOptions] = useState<any[]>([]);

  const getSelectionFilterOptions = useCallback(() => {
    let formattedOptions: any[] = [];
    if (filterType === SearchFiltersTypes.PROPERTY_TYPES) {
      filterOptions[SearchFiltersTypes.PROPERTY_TYPES].map((option: any) => {
        let typeIndex = filterOptions[
          SearchFiltersTypes.PROPERTY_TYPES
        ].findIndex(type => type.value == option.id);
        formattedOptions.push({
          id: option.value,
          icon: option.options.image,
          name: option.options.displayedValue
        });
      });

      setOptions(formattedOptions);
    }

    // if (filterType === SearchFiltersTypes.DELIVERY_DATE) {
    //   handleSelectOptionsWithMaxValue(
    //     filterOptions[filterType],
    //     2030,
    //     setOptions
    //   );
    // }
  }, [quickFilter]);
  useEffect(() => {
    if (compounds) {
      getSelectionFilterOptions();
    }
  }, [compounds, quickFilter]);
  return (
    <Container>
      <div className="options">
        {options
          .filter(option =>
            quickFilter === QuickFilter.PROPERTY_TYPE ? option.name : true
          )
          .map((option, index) => (
            <MultiSelectFilterCard
              key={option?.id ?? option?.value}
              id={option?.id}
              index={index}
              icon={option?.icon}
              name={option?.name}
              filterValue={option?.value}
              options={option?.options}
              filterType={filterType}
            />
          ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    width: 100%;
  }

  .header {
    font-size: 18px;
    font-family: materialSemiBold;
    color: #282828;
  }
`;

export default SelectionFilter;
